<div class="col-xs-12" id="orders_topcontent">
  <div class="col-xs-12 col-md-12 order_banner_uk" id="orders_topcontentleftcontent">
    <div class="col-xs-12 orders_titeltop_uk no-padding">{{"ordersummary.title" | cxTranslate}}</div>
    <div class="col-xs-12 orders_righttitle_uk no-padding" appRouterlinkinterceptor [innerHTML]="'ukordersummary.submessage' | cxTranslate">
    </div>
  </div>
</div>

<section>
  <div id="ordersummary_OM_seasonConfirmPopup" class="modal fade" role="dialog" [ngClass]="enablepopup?.popup?'show':'hide'">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          @if (!ordersummarydata?.prePrebookEnabled) {
            <h4 class="modal-title OMconfirm_popHeader col-xs-10">{{'ukordersummary.subtxt' | cxTranslate}}{{enablepopup?.season | seasonspilt}} season</h4>
          }
          @if (ordersummarydata?.prePrebookEnabled) {
            <h4 class="modal-title OMconfirm_popHeader col-xs-10">{{'ukordersummary.presubtxt' | cxTranslate}}{{enablepopup?.season | seasonspilt}} season</h4>
          }
          <div class="col-xs-2">
            <span class="OMconfirm_popClose" data-bs-dismiss="modal" (click)="closepop()">×</span>
          </div>
          <p class="OMconfirm_popSubHeader col-xs-12">{{'ukordersummary.continueqstn' | cxTranslate}}</p>
          <div class="clearboth"></div>
          <div class="OMconfirm_PopBtnParent">
            <button class="OM_popBackBtn seasonPopUpBackButton" data-bs-dismiss="modal">{{'ukordersummary.choosediffseason' | cxTranslate}}</button>
            <button class="OM_popContBtn" data-bs-dismiss="modal" (click)="continue(enablepopup?.season);closepop()">{{'ukordersummary.continuelabel' | cxTranslate}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
